import Product from "../entities/Product";
import products from "../helpers/products";
export function loadCatalog() {
    var loadData = localStorage.getItem("products");
    var loadDataJson;
    if (loadData) {
        loadDataJson = JSON.parse(loadData);
    }
    else {
        localStorage.setItem("products", JSON.stringify(products()));
        loadData = localStorage.getItem("products");
        loadDataJson = JSON.parse(loadData);
    }
    var catalog = [];
    loadDataJson.forEach(function (element) {
        var prod = new Product();
        prod.create(element);
        catalog.push(prod);
    });
    return catalog;
}
export function postCatalog(catalog) {
    localStorage.setItem("products", JSON.stringify(catalog));
}
